import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import { ExportToCsv } from 'export-to-csv';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-coupon-product-list',
  templateUrl: './coupon-product-list.component.html',
  styleUrls: ['./coupon-product-list.component.scss']
})
export class CouponProductListComponent implements OnInit {

  public loginData: any;

  public coupons: any = [];
  public couponsPage: number = 0; // Always 0
  public couponsLoading: boolean = false;

  public selectedStore: any;
  public couponSource: string;
  public couponStatus: string = 'active'; // Always active
  public demoStatus: any = 0; // Always 0

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { 
    if (this._router.getCurrentNavigation().extras.state) {
      this.selectedStore = this._router.getCurrentNavigation().extras.state.store;
      this.couponSource = this._router.getCurrentNavigation().extras.state.couponSource;
    }
  }

  ngOnInit(): void {
    this.getStorageData();
  }

  // Back to coupon list
  onBackClick(){
    this._router.navigate(['/retailer/coupons'], {
      state: {}
    });
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    // Back to coupons page if selected store is missing
    if (!this.selectedStore) {
      this._router.navigate(['/retailer/coupons']);
    } else {
      this.getCoupons();
    }
  }

  // Get coupons
  getCoupons() {
    this.coupons = [];
    this.couponsLoading = true;

    this._couponsService.getCoupons(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, this.loginData.user_details.provider_id, this.selectedStore, this.couponSource, this.couponStatus, this.couponsPage, this.demoStatus).subscribe(async getCouponsResponse => {
      this.couponsLoading = false;

      if (getCouponsResponse.status === true) { // Success
        this.coupons = getCouponsResponse.coupons;
      } else {
        this._utilService.showToast(getCouponsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getCoupons
      this.couponsLoading = false;
    });
  }

  // Generate CSV File
  generateCSVFile() {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: false,
      useKeysAsHeaders: true,
      filename: 'coupon-products'
    };
    const csvExporter = new ExportToCsv(options);

    let couponProductsCSV: any = [];
    for (let i=0; i<=this.coupons.length-1; i++) {
      for (let j=0; j<=this.coupons[i].products.length-1; j++) {
        couponProductsCSV.push({
          coupon_title: this.coupons[i].coupon_title,
          product_count: this.coupons[i].products.length,
          product_name: this.coupons[i].products[j].item_name,
          upc: this.coupons[i].products[j].upc
        })
      }
    }
    csvExporter.generateCsv(couponProductsCSV);
  }

}
